import React from 'react';
import { Refresh } from 'V2/Shared/Icons';
import styles from './styles.module.css';

interface ErrorRetryProps {
  children: React.ReactNode;
  onRetry?: () => void;
}

export const ErrorRetry: React.FC<ErrorRetryProps> = ({
  children,
  onRetry,
}) => (
  <div className={styles.errorBox} role="alert">
    <p className={styles.message}>{children}</p>
    {onRetry && (
      <button
        type="button"
        onClick={onRetry}
        className={styles.retryButton}
        aria-label="Retry"
      >
        <Refresh color="#721c24" />
        Retry
      </button>
    )}
  </div>
);
